import { useEffect, useState } from 'react';
import SnackBar from 'components/SnackBar';
import FormGroup from '../../FormGroup';
import SectionHeader from '../../SectionHeader';
import usePostData from '../../../hooks/usePostData';
import useFetchData from '../../../hooks/useFetchData';
import fields from '../fields';
import { useParams } from 'react-router-dom';

const BloodParamPage = () => {
  const { idd } = useParams();
  const [currentBloodParam, setCurrentBloodParam] = useState();
  const { postData, res, payload, error } = usePostData();
  const [showSnackbar, setShowSnakbar] = useState(false);
  const [errFun, setErrFun] = useState();

  let { data } = useFetchData('blood-param', idd);

  useEffect(() => {
    setCurrentBloodParam(data);
  }, [data]);

  useEffect(() => {
    if (error)
      errFun?.set('apiError', {
        type: 'string',
        message: error.apiError
      });
    else if (res && res.affected === 1 && payload) {
      setCurrentBloodParam(payload);
      setShowSnakbar(true);
    }
  }, [res, payload, error]);

  const onSubmit = (data, setError) => {
    setErrFun({ set: setError });
    let deepData = { ...data };
    delete deepData.id;
    console.log('update user data  :', deepData);
    postData(`blood-param/${idd}`, deepData, 'patch');
  };

  return (
    <div className="blood-param-page">
      {currentBloodParam && (
        <div>
          <SectionHeader title={`${currentBloodParam?.name}`}></SectionHeader>
          <FormGroup
            fields={fields()}
            data={currentBloodParam}
            onSubmit={onSubmit}
          ></FormGroup>
          {showSnackbar && (
            <SnackBar
              msg={'מדד עודכן'}
              handleClose={() => setShowSnakbar(false)}
            ></SnackBar>
          )}
        </div>
      )}
    </div>
  );
};

export default BloodParamPage;
